


export default class ToolTip{
    constructor(){
        this.bindEvents();
    }
    bindEvents = () =>{
        this.makeTooltip();
    }

    makeTooltip = () =>{
        let glossaryLinks = $('.glossaryLink');
        let _this = this;
        if(glossaryLinks.length){
            glossaryLinks.each(function(){
                let tooltipContent = $(this).data('cmtooltip');
                tooltipContent = '<div class="glossaryTooltip">'+tooltipContent+'</div>';
                $(this).append(tooltipContent);
                let currentTooltip =  $(this).find('.glossaryTooltip');
             
                let currentElement = $(this);
                if(currentTooltip.css('text-align') == 'center'){
                    currentTooltip.addClass('centerAlign');
                }
                else if(currentTooltip.css('text-align') == 'right'){
                    currentTooltip.addClass('rightAlign');
                }else{
                    currentTooltip.addClass('leftAlign');
                }
                currentTooltip.css({textAlign:'left'});
                _this.checkViewPort(currentElement, currentTooltip);

                $(window).scroll(function(){
                    _this.checkViewPort(currentElement, currentTooltip);
                  
                })
                $(this).hover(function(){
                    currentTooltip.css({visibility:'visible',opacity:1})
                },
                function(){
                    currentTooltip.css({visibility:'hidden',opacity:0})
                });

            });
        }
    }
    checkViewPort = (currentElement, currentTooltip) =>{
        let threshold = this.elementAtViewportTop(currentElement);
                    
        if(!threshold){
            currentTooltip.addClass('pointTop');
            currentTooltip.removeClass('pointDown');

        }
        else{
            currentTooltip.addClass('pointDown');
            currentTooltip.removeClass('pointTop');
        }
    }
    elementAtViewportTop = (elem) => {
        if(!elem || typeof elem !== "object") return false;
        if(elem instanceof jQuery) elem = elem[0];
 
        var elemClientRect = elem.getBoundingClientRect();
        
        return (elemClientRect.top <= 276 && elemClientRect.top > -(elemClientRect.height+250));
    }

}
